'use client'

import { type PropsWithChildren } from 'react'

import { type AnalyticsEvents } from '@src/hooks/useClickAction/useClickAction.builder'

import { ActionLink } from '../ActionLink/ActionLink'

interface CdpTileProps extends PropsWithChildren {
  title: string
  description: string
  featureTags: Array<{ value: string }>
  price: string
  promotionalPrice?: string
  href?: string
  target?: '_self' | '_blank'
  analyticsEvent?: (typeof AnalyticsEvents)[number]
  analyticsModule?: string
}

export const CdpTile = ({
  children,
  title,
  description,
  featureTags,
  price,
  promotionalPrice,
  href,
  target,
  analyticsEvent,
  analyticsModule,
}: CdpTileProps) => {
  return (
    <ActionLink
      analyticsModule={analyticsModule}
      actionName="navigate"
      navigate={{ href, target, analyticsEvent }}
      className="h-full *:h-full *:rounded-[32px]"
    >
      <div className="flex h-full w-[330px] flex-col gap-4 rounded-3xl bg-white pb-4 transition-all hover:drop-shadow-md lg:rounded-[32px]">
        <div className="relative h-[220px] w-full overflow-hidden rounded-t-[32px] [&_div]:size-full [&_img]:h-full [&_img]:w-auto [&_img]:max-w-none">
          {children}
        </div>
        <div className="flex flex-1 flex-col gap-3 px-4">
          <div className="flex flex-col gap-2">
            <h2 className="text-body-lg font-medium">{title}</h2>
            <p className="text-body-sm">{description}</p>
          </div>
          <div className="flex flex-row flex-wrap gap-2">
            {featureTags?.map((tag, idx) => {
              return (
                <div
                  key={idx}
                  className="flex h-7 items-center rounded-full bg-bodi-gray-pearl px-3 text-body-sm whitespace-nowrap"
                >
                  {tag.value}
                </div>
              )
            })}
          </div>
          <div className="text-heading-4 mt-auto flex flex-row items-start gap-2">
            {promotionalPrice ? (
              <>
                <div className="text-bodi-gray-medium">
                  <s>{price}</s>
                </div>
                <div>{promotionalPrice}</div>
              </>
            ) : (
              <div>{price}</div>
            )}
          </div>
        </div>
      </div>
    </ActionLink>
  )
}
